import { deleteRequestHandler, getRequestHandler, postRequestHandler } from '../utils/utils';
import { BASE_CORE_URL, BASE_CORE_URL_TEST1, BASE_URL, UAPI_URL_ALERT, UAPI_URL_CONFIG, UAPI_URL_DASHBOARD_CONFIG } from './../config/index'

//#region to get the dashboard details
export const GetDashboardDetails = async (obj) => {
  const requestOptions = {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "authcode": localStorage.getItem('authCode'),
      "Authorization": "Bearer " + localStorage.getItem('authToken'),
    },
    body: JSON.stringify(obj),
  };
return null;
  let url = BASE_URL + "getdashboarddetails";
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getdashboarddetails() Exception: ", error);
    });
}
//#endregion 

//#region to get the system health device count 
export const SystemHealthDevicesCountDash = async (userUniqueID) => {
  let url = BASE_CORE_URL + "Dashboard/SystemHealth?userUniqueId=" + userUniqueID;
  return getRequestHandler(url)
}
//#endregion

//#region - to get the  data of dashboard Side bar Customurl list (Test,etc.,)
export const MenuMasterListAPI = async () => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken'),
      },
    };
    let url = BASE_CORE_URL + "Dashboard/GetCustomURLList";

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("MenuMasterListAPI() Exception:", error);
    return null; // or handle the error as needed
  }
};
//#endregion


//UAPI Consumption

//#region --> to getting the Camera Count
export const GetDeviceCount = async (userID) => {
  let url = UAPI_URL_CONFIG + "homePage/getDeviceCount?userID=" +userID;
  return getRequestHandler(url)
}
//#endregion

//#region --> to getting the site count 
export const GetSiteCount = async (userID) => {
  let url = UAPI_URL_CONFIG + "homePage/getSiteCount?userID=" +userID;
  return getRequestHandler(url)
}
//#endregion

//#region --> getting the Todays Alert Count
export const GetTodaysAlertCount = async (userID,fromDateTime,ToDateTime) => {
  let url = UAPI_URL_CONFIG + "homePage/getTodaysAlertCount?userID=" + userID + "&fromDateTime=" + fromDateTime + "&toDateTime=" + ToDateTime;
  return getRequestHandler(url)
}

export const GetSystemHealth = async (userId) => {
  let url = UAPI_URL_CONFIG + "homePage/getSystemHealth?userId=" + userId ;
  return getRequestHandler(url)
}

export const GetTodaysAlertListUAPI = async (obj) => {
  let url = UAPI_URL_CONFIG + "homePage/getTodaysAlertList";
  return postRequestHandler(url, obj)
}

export const GetMaxSeverityAlertTitle = async (userID) => {
  let url = UAPI_URL_CONFIG + "homePage/getMaxSeverityAlert?userID=" + userID;
  return getRequestHandler(url)
}

export const GetDashboardWorkflow = async (AlertDate) => {
  let url = UAPI_URL_CONFIG + "homePage/getDashboardWorkFlowCount?userID=" + localStorage.getItem('UserID') + "&AlertDate=" +AlertDate;
  return getRequestHandler(url)
}


export const GetUserCountStatus = async (UserId) => {
  const requestOptions = {
    method: "GET",
      headers: {
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken'),
      },
  };

  let url = UAPI_URL_ALERT + "alerts/getUserCount?UserId=" + UserId;
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getTodaysAlertCount() Exception: ", error);
    });
}



export const GetDashbordAlertStatus = async (
  UserId, 
  widgetId,
  fromDateTime,
  toDateTime,  
  alertStatus,
  alertSeverity,
  alertAssociated,
  interfacetypename,
  clientID,
  siteID,
  hourly,
  dayName,
  weekNumber,
  monthName,
  clientName,
  siteName
) => {
  const requestOptions = {
    method: "GET",
      headers: {
        "Content-Type": "application/json",
        "authcode": localStorage.getItem('authCode'),
        "Authorization": "Bearer " + localStorage.getItem('authToken'),
      },
  };

  let url = UAPI_URL_DASHBOARD_CONFIG  +
   "getData/?userId=" + 
   UserId + 
   "&widgetId=" + 
   widgetId +
   "&fromDateTime=" +    
   fromDateTime + 
   "&toDateTime=" + 
   toDateTime +    
   "&alertStatus=" +
   alertStatus +
   "&severityTitle=" +
   alertSeverity +
   "&alertAssociated=" +
   alertAssociated +
   "&interfaceTypeName=" +
   interfacetypename +
   "&customerId=" +
   clientID +
   "&siteId="+
   siteID +
   "&hourly=" +
   hourly +
   "&daily=" + 
   dayName +
   "&weekly=" +
   weekNumber +
   "&monthly=" +
   monthName +
   "&clientName=" +
   clientName +
   "&siteName=" + 
   siteName;
  
  return await fetch(url, requestOptions)
    .then((resp) => resp.json())
    .then(function (data) {
      return data;
    })
    .catch(function (error) {
      console.error("getTodaysAlertCount() Exception: ", error);
    });
}

export const getWidgetList = async (obj) => {
  const { UserID } = obj;
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getWidgetList?UserID=${UserID}`;
  return getRequestHandler(url, obj);
}

export const getAlertsData = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getAlertsData`;
  return postRequestHandler(url, obj)
};

export const getDeviceStatusData = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getDeviceStatus`;
  return postRequestHandler(url, obj)
};

export const getConsolidatedData = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getConsolidatedData`;
  return postRequestHandler(url, obj)
};

export const getVideoBackupData = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getVideoBackupData`;
  return postRequestHandler(url, obj)
};

export const getVideoBackupActivityTimeline = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getVideoBackupActivityTimeline`;
  return postRequestHandler(url, obj);
};

export const getAddLayout = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}addLayout`;
  return postRequestHandler(url, obj)
};

export const getAddedLayout = async (obj) => {
  const { UserID } = obj;
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getLayout?UserID=${UserID}`;
  return getRequestHandler(url, obj);
}

export const getUpdateLayout = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}updateLayout`;
  return postRequestHandler(url, obj)
};

export const getAlertDataDetailed = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getAlertDataDetailed`;
  return postRequestHandler(url, obj)
};

export const getConsolidatedDataDetailed = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getConsolidatedDataDetailed`;
  return postRequestHandler(url, obj)
};

export const getDeviceDataDetailed = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getDeviceDataDetailed`;
  return postRequestHandler(url, obj)
};
export const getVideoBackupDataDetailed = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getVideoBackupDataDetailed`;
  return postRequestHandler(url, obj)
};

export const getDashboardFilters = async (obj) => {
  const { UserID } = obj;
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getDashboardFilters?UserID=${UserID}`;
  return getRequestHandler(url, obj);
};

export const addDashBoardWidgetAccess = async (obj) => {
  const { UserID } = obj;
  const url = `${UAPI_URL_DASHBOARD_CONFIG}addDashBoardWidgetAccess`;
  return postRequestHandler(url, obj);
};

export const getDashBoardWidgetUserList = async (obj) => {
  const url = `${UAPI_URL_DASHBOARD_CONFIG}getDashBoardWidgetUserList`;
  return postRequestHandler(url, obj);
};

export const deleteWidgetAccess = async (obj) => {
  const { UserID, widgetID } = obj;
  const url = `${UAPI_URL_DASHBOARD_CONFIG}deleteWidgetAccess?UserID=${UserID}&WidgetID=${widgetID}`;
  return deleteRequestHandler(url, obj);
};


export const GetDynamicSidebarMenu = async () => {
  let url = UAPI_URL_CONFIG + "homePage/getMenuExternalLink"
  return getRequestHandler(url)
}

export const createExportRequest = async (obj) => {
  let url = UAPI_URL_DASHBOARD_CONFIG + "createExportRequest";
  return postRequestHandler(url, obj)
}